import React from 'react';

const Icon = props => {
  const { className, contents, name, ...rest } = props;
  const Svg = contents;
  return (
    <div id={name} data-type="icon-wrapper" className={className}>
      <Svg {...rest} />
    </div>
  );
};

export default Icon;
